import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {Tooltip} from '@mui/material';
import {GridLinkButton} from 'components/common/GridLinkButton';
import {DEFAULT_DATE_FORMAT} from '../../../constants/reports';
import DateFnsUtils from '@date-io/date-fns';
import {Chip} from '@mui/material';
import {styled} from '@mui/material/styles';
import {formatRoleToLabel} from 'utils/common';

const dateFns = new DateFnsUtils();
const ActiveUserChip = styled(Chip)(()=>({
    marginLeft: '8px',
    height: '24px',
    ['& .MuiChip-label']: {
        padding: '0 8px',
    },
}));
export const USER_COLUMNS = [{
    field: 'id',
    headerName: 'Name',
    sortable: true,
    flex: 1,
    valueGetter: (_, row)=>`(${row.id}) ${row.name}`,
    renderCell: ({value, row: {id, current}}) => {
        return (
          <Tooltip title={value} placement='top'>
            <GridLinkButton component={RouterLink} to={`/users/${id}/edit`}>{value}{current?<ActiveUserChip color='info' label='You' />:null}</GridLinkButton>
          </Tooltip>
        );
    },
}, {
    field: 'email',
    headerName: 'Email',
    flex: 1,
}, {
    field: 'role',
    headerName: 'Role',
    flex: 1,
    valueFormatter: (value)=>formatRoleToLabel(value),
}, {
    field: 'createdAt',
    headerName: 'Created At',
    flex: 1,
    valueFormatter: (value) => (value ? dateFns.format(new Date(value), DEFAULT_DATE_FORMAT): value),
}];
